import styled from 'styled-components';
import { OutlinedCard as DefaultOutlinedCard, Button } from '~components';
import { ChevronDownProps } from './types';

export const OutlinedCard = styled(DefaultOutlinedCard)`
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing.km4};
  padding: ${({ theme }) => theme.spacing.km8};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km4};
  }
`;

export const ChevronDown = styled(Button).attrs({
  variant: 'icon',
})<ChevronDownProps>`
  transform: ${({ isOpenAccordion }) =>
    isOpenAccordion ? 'rotate(180deg)' : 'rotate(0deg)'};
  position: absolute;
  cursor: pointer;
  color: ${({ theme }) => theme.color.icon.brand.default};

  top: ${({ theme }) => theme.spacing.km12};
  right: ${({ theme }) => theme.spacing.km6};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    top: ${({ theme }) => theme.spacing.km1};
  }
`;

export const PersonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 600px) {
    flex-direction: row;

    > div {
      width: 310px;
    }
  }
`;
